import { FleetVehicleEditFormValues } from "services/api/fleet/vehicles/types";
import { FleetVehicleTireRow } from "services/api/fleet/vehicles/tires/types";
import { Errors } from "services/forms/validation/types";
import { VehicleInfo } from "../VehicleSummaryCard/types";

export interface VehicleTireFormRef {
  /** Sprema sve promijenjene gume. Vraća broj spremljenih, -1 na grešku. */
  saveAll: () => Promise<number>;
}

export interface VehicleTireFormProps {
  formValues: FleetVehicleEditFormValues;
  setFormValues: React.Dispatch<
    React.SetStateAction<FleetVehicleEditFormValues>
  >;
  setVehicleInfo: React.Dispatch<React.SetStateAction<VehicleInfo>>;
  errors?: Errors;
}

/*---------------------------------------------------------------
    INLINE EDIT - stanje pojedinog reda gume
  ---------------------------------------------------------------*/
export interface TireRowEditState {
  width: number | null;
  height: number | null;
  radius: number | null;
  tireTypeId: string | null;
  tireManufacturerId: string | null;
  dot: number | null;
  profileDepth: number | null;
  rof: boolean;
  axlePosition: number | null;
  isDirty: boolean;
  dirtyFields: Set<string>;
}

export type TireRowEditMap = Record<string, TireRowEditState>;

/*---------------------------------------------------------------
    HELPER - pretvorba API reda u edit stanje
  ---------------------------------------------------------------*/
export const initTireRowEditState = (tire?: FleetVehicleTireRow): TireRowEditState => ({
  width: tire?.width ?? null,
  height: tire?.height ?? null,
  radius: tire?.radius ?? null,
  tireTypeId: tire?.tireType?.id ?? null,
  tireManufacturerId: tire?.tireManufacturer?.id ?? null,
  dot: tire?.dot ?? null,
  profileDepth: tire?.profileDepth ?? null,
  rof: tire?.rof ?? false,
  axlePosition: tire?.axlePosition ?? null,
  isDirty: false,
  dirtyFields: new Set<string>(),
});
